<template>
  <div class="app-container view-container bj-label-colon">
    <!-- 订单基本信息 -->
    <BjDivider right-fixed>{{ $t('orderNewPatch.Information') }}
      <template slot="right">
        <template v-if="!isView">
          <el-button @click="tryCancel">{{ $t('cancelText') }}</el-button>
          <el-button type="primary" :loading="isSubmitting" @click="onConfirm">{{ $t('saveText') }}</el-button>
        </template>
        <template v-if="isView">
          <el-button type="primary" @click="cancel">{{ $t('backText') }}</el-button>
        </template>
      </template>
    </BjDivider>
    <el-form ref="form" :model="form" label-position="top" :rules="rules" label-width="160px">
      <el-row>
        <!-- 客户订单号 -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('orderNewPatch.CustomerOrder')" prop="orderBaseInfoDTO.outerOrderNo">
            <BjInput v-model="form.orderBaseInfoDTO.outerOrderNo" :maxlength="MAX_LENGTH.DEFAULT" show-word-limit />
          </el-form-item>
        </el-col>
        <!-- 渠道、店铺 -->
        <BjSelectChannelStore :span="colSpan" :query-params="form.orderBaseInfoDTO" :query-keys="['channel', 'storeCode']" :query-props="['orderBaseInfoDTO.channel', 'orderBaseInfoDTO.storeCode']" :query-labels="[$t('SalesOrderEntry.channel'), $t('SalesOrderEntry.store')]" store-option-value="code" @handleChannelChange="onChangeChannel" @handleStoreChange="onChangeStore" />
        <!-- 平台下单时间 -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('orderNewPatch.Ordered')" prop="orderBaseInfoDTO.orderTime">
            <BjDateTimerPicker v-model="form.orderBaseInfoDTO.orderTime" />
          </el-form-item>
        </el-col>
        <!-- 商家备注 -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('SalesOrderEntry.Notes')" prop="orderBaseInfoDTO.orderRemarks">
            <el-input v-model="form.orderBaseInfoDTO.orderRemarks" :maxlength="MAX_LENGTH.PRIORITY" type="textarea" show-word-limit autosize :placeholder="$t('SalesOrderEntry.Notes')" />
          </el-form-item>
        </el-col>
        <!-- 运输方式 -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessPurchaseOrder2.means')" prop="orderBaseInfoDTO.shippingMethod">
            <BjSelectLov v-model="form.orderBaseInfoDTO.shippingMethod" :option-list="CSG_ORDER_SHIPPING_METHODS_LIST" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <!-- 'CSG MANUAL' -->
        <template v-if="isCSGShow">
          <!-- 审核报价 -->
          <el-col :span="colSpan/2">
            <el-form-item :label="$t('WarehouseManagement.form.isQuotation')" prop="isQuota">
              <el-switch v-model="isQuota" active-color="#082dc3" inactive-color=""></el-switch>
            </el-form-item>
          </el-col>
          <!-- 是否指定物流 -->
          <el-col :span="colSpan/2">
            <el-form-item :label="$t('WarehouseManagement.form.isLogisticsSpecified')">
              <el-switch v-model="isLogisticsSpecified" disabled active-color="#082dc3" inactive-color=""></el-switch>
            </el-form-item>
          </el-col>
          <!-- 物流信息 -->
          <el-col v-if="isLogisticsSpecified" :span="colSpan">
            <el-form-item :label="$t('WarehouseManagement.form.chooseLogistics')" prop="LogisticsSelectionDataRule">
              <BjSelectLov v-model="form.orderBaseInfoDTO.logisticsBusinessName" :option-list="LogisticsSelectionData" @change="logsome" />
            </el-form-item>
          </el-col>
          <!-- 送货预约时间 -->
          <el-col :span="colSpan">
            <el-form-item :label="$t('BusinessThirdOrderAdd.deliveryAppointmentTime')">
              <BjDateTimerPicker v-model="form.orderBaseInfoDTO.deliveryAppointmentTime" />
            </el-form-item>
          </el-col>
        </template>
        <!-- 'CUSTOMER MANUAL' -->
        <template v-if="isCustomerShow">
          <!-- 物流信息 -->
          <el-col :span="colSpan">
            <el-form-item :label="$t('WarehouseManagement.form.chooseLogistics')">
              <BjSelectLov v-model="form.orderBaseInfoDTO.logisticsBusinessName" :option-list="LogisticsSelectionData" @change="logsome" />
            </el-form-item>
          </el-col>
          <!-- 物流单号 -->
          <el-col :span="colSpan">
            <el-form-item :label="$t('OrdinaryOrderMix.LogisticsTable.logisticsNo')" prop="orderBaseInfoDTO.logisticsNo">
              <BjInput v-model="form.orderBaseInfoDTO.logisticsNo" clearable />
            </el-form-item>
          </el-col>
          <!-- 托盘数量 -->
          <el-col :span="colSpan">
            <el-form-item :label="$t('WarehouseManagement.form.need')" prop="palletQty">
              <BjInputNumber v-model="form.orderBaseInfoDTO.palletQty" clearable />
            </el-form-item>
          </el-col>
          <!-- 预计取货时间 -->
          <el-col :span="colSpan">
            <el-form-item :label="$t('WarehouseManagement.form.time')" prop="truckPickupTime">
              <BjDateTimerPicker v-model="form.orderBaseInfoDTO.truckPickupTime" />
            </el-form-item>
          </el-col>
          <!-- 是否需要仓库提供尺寸信息 -->
          <el-col :span="colSpan">
            <el-form-item :label="$t('WarehouseManagement.form.check')" prop="isProvideSize">
              <el-switch v-model="form.orderBaseInfoDTO.isProvideSize" active-color="#082dc3" inactive-color=""></el-switch>
            </el-form-item>
          </el-col>
        </template>
      </el-row>
      <el-row>
        <template>
          <!-- 物流单：只有CUSTOMER MANUAL才有 -->
          <!-- shippingLabels -->
          <el-col v-show="isCustomerShow" :span="colSpan">
            <el-form-item :label="$t('OrdinaryOrderMix.LogisticsTable.Shipment')">
              <UploadFile ref="UploadFileRef1" class="avatar-uploader" :limit="20" :limit-size="5 * 1024" multiple show-file-list accept="image/png,image/jpeg,.csv,.pdf,.doc,.docx,.xlsx" :accept-list="['image/jpeg', 'image/png', '.csv', '.pdf', '.doc', '.xlsx']" auto-upload limit-hide @handleFileListChange="fileListChange1">
                <template slot="default">
                  <el-button size="small" type="primary">{{ $t('BusinessImportHistory.page.SelectFile') }}</el-button>
                </template>
                <template slot="tip">
                  <div class="hint">
                    <p> 1.{{ $t('OrdinaryOrderMix.LogisticsTable.ps1') }}</p>
                    <p> 2.{{ $t('OrdinaryOrderMix.LogisticsTable.ps2') }}</p>
                  </div>
                </template>
              </UploadFile>
            </el-form-item>
          </el-col>
          <!-- 其他相关文件 -->
          <!-- orderMaterialList -->
          <el-col :span="colSpan">
            <el-form-item :label="$t('OrdinaryOrderMix.LogisticsTable.Supporting')">
              <UploadFile ref="UploadFileRef2" class="avatar-uploader" :limit="20" :limit-size="5 * 1024" multiple show-file-list accept="image/png,image/jpeg,.csv,.pdf,.doc,.docx,.xlsx" :accept-list="['image/jpeg', 'image/png', '.csv', '.pdf', '.doc', '.xlsx']" auto-upload limit-hide @handleFileListChange="fileListChange2">
                <template slot="default">
                  <el-button size="small" type="primary">{{ $t('BusinessImportHistory.page.SelectFile') }}</el-button>
                </template>
                <template slot="tip">
                  <div class="hint">
                    <p> 1.{{ $t('OrdinaryOrderMix.LogisticsTable.ps3') }}</p>
                  </div>
                </template>
              </UploadFile>
            </el-form-item>
          </el-col>
        </template>
      </el-row>

      <!-- 收货人信息 -->
      <BjDivider>{{ $t('orderNewPatch.Receiver') }}</BjDivider>
      <el-row>
        <!-- 收货人 -->
        <el-col v-if="!cptIsPickSelf" :span="colSpan">
          <el-form-item :label="$t('SalesOrderEntry.Consignee')" prop="orderBuyerInfoDTO.receiverName">
            <BjInput v-model="form.orderBuyerInfoDTO.receiverName" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" />
          </el-form-item>
        </el-col>
        <!-- 收货人手机号 -->
        <el-col :span="colSpan">
          <el-form-item :label="cptIsPickSelf ? $t('SalesOrderEntry.phone') : $t('SalesOrderEntry.mobile')" prop="orderBuyerInfoDTO.deliveryPhone">
            <BjInput v-model="form.orderBuyerInfoDTO.deliveryPhone" onkeyup="this.value = this.value.replace(/[^\d]/g,'');" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" />
          </el-form-item>
        </el-col>
        <!-- 邮箱 -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('ExternalOrders.newAdd.emailAddress')" prop="orderBuyerInfoDTO.deliveryEmailAddress" :rules="{ required:false, validator: validatorEmail, trigger: 'blur'}">
            <BjInput v-model="form.orderBuyerInfoDTO.deliveryEmailAddress" :maxlength="MAX_LENGTH.NORMAL_REMARK" :placeholder="$t('inputText')" />
          </el-form-item>
        </el-col>
        <!-- 国家 -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('WarehouseManagement.form.country')" prop="orderBuyerInfoDTO.country" :rules="{ required:true, message: $t('chooseText'), trigger: 'change'}">
            <BjSelectLov v-model="form.orderBuyerInfoDTO.country" :option-list="COUNTRY_NAME_AND_TWOCODE" :placeholder="$t('chooseText')" />
          </el-form-item>
        </el-col>
        <!-- 州 -->
        <el-col :span="colSpan">
          <el-form-item v-if="form.orderBaseInfoDTO.shippingMethod === 'PICKUP' || ['TW','HK','MO','SG','GB','IE','IL','IS','AE','MC','BH','VA','SZ','MV','NZ','SM','LI','AD','BS'].includes(form.orderBuyerInfoDTO.country)" :label="$t('WarehouseManagement.form.state')" prop="orderBuyerInfoDTO.province" :rules="{ required:false, message: $t('inputText'), trigger: 'blur'}">
            <BjInput v-model="form.orderBuyerInfoDTO.province" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" />
          </el-form-item>
          <el-form-item v-else :label="$t('WarehouseManagement.form.state')" prop="orderBuyerInfoDTO.province" :rules="{ required: true, validator: validatorAddress1, trigger: 'blur'}">
            <BjInput v-model="form.orderBuyerInfoDTO.province" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" />
          </el-form-item>
        </el-col>
        <!-- 郊区 -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('WarehouseManagement.form.city')" prop="orderBuyerInfoDTO.district" :rules="{ required: form.orderBaseInfoDTO.shippingMethod !== 'PICKUP', validator: validatorAddress1, trigger: 'blur'}">
            <BjInput v-model="form.orderBuyerInfoDTO.district" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" />
          </el-form-item>
        </el-col>
        <!-- 邮编 -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('WarehouseManagement.form.postcode')" prop="orderBuyerInfoDTO.zipCode" :rules="{ required: form.orderBaseInfoDTO.shippingMethod !== 'PICKUP', validator: validatorPostCode, trigger: 'blur'}">
            <BjInput v-model="form.orderBuyerInfoDTO.zipCode" :maxlength="MAX_LENGTH.SHORT_NAME" :placeholder="$t('inputText')" />
          </el-form-item>
        </el-col>
        <!-- 邮寄地址1 -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('ExternalOrders.newAdd.DeliveryAddress1')" prop="orderBuyerInfoDTO.deliveryAddress1" :rules="{ required: form.orderBaseInfoDTO.shippingMethod !== 'PICKUP', validator: validatorAddress1, trigger: 'blur'}">
            <BjInput v-model="form.orderBuyerInfoDTO.deliveryAddress1" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" />
          </el-form-item>
        </el-col>
        <!-- 邮寄地址2 -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('ExternalOrders.newAdd.DeliveryAddress2')" prop="orderBuyerInfoDTO.deliveryAddress2" :rules="{ required: false, validator: validatorAddress2, trigger: 'blur'}">
            <BjInput v-model="form.orderBuyerInfoDTO.deliveryAddress2" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('SalesOrderEntry.address')" clearable />
          </el-form-item>
        </el-col>
      </el-row>

      <!-- 商品信息 -->
      <BjDivider>{{ $t('SalesOrderEntry.Product') }}
        <template v-slot:button>
          <el-button :disabled="SELECTED_BJ_EBC_ID.length === 0" type="danger" @click="batchDelete">{{ $t('SalesOrderEntry.delete') }}</el-button>
          <el-button type="primary" @click="addGoodsDialog('dialogListOrdinarySku')">{{ $t('SalesOrderEntry.ordinary') }}</el-button>
          <el-button type="primary" @click="addGoodsDialog('dialogListPackAgeSku')">{{ $t('SalesOrderEntry.package') }}</el-button>
        </template>
      </BjDivider>

      <OrderItemTable ref="OrderItemTable" :disabled="false" :is-show="!$store.getters.cusId" :is-true="false" :table-data.sync="form.orderItemDTOList" @delete="onDelete" @selection-change="handleSelectionChange" />
    </el-form>
    <!-- 选择普通商品 -->
    <BjDialogList ref="dialogListOrdinarySku" width="80%" :config="
            $BjDialogListConfig.skuDefault($t('SalesOrderEntry.goods'), {
              defaultQuery: { setFlag: 0, status: [3, 5], isHide: 0,itemType:'item' },columns:[
              {
                prop: 'skuName',
                label: 'BjDialogListConfig.SKUname',
                width: 160,
              },
              {
                prop: 'standardSkuCode',
                label: 'BjDialogListConfig.SKUcode',
                width: 160,
              },
              {
                prop: 'usableNum',
                label: 'BjDialogListConfig.Available',
                width: 160,
              },
            ]
            })
          " multiple @confirm="onAddGoodsDialogConfirm" />
    <!-- 选择组合商品 -->
    <BjDialogList ref="dialogListPackAgeSku" width="80%" :config="
            $BjDialogListConfig.skuDefault($t('SalesOrderEntry.Add'), {
              defaultQuery: { setFlag: 1, status: [3, 5] },columns:[
              {
                prop: 'skuName',
                label: 'BjDialogListConfig.SKUname',
                width: 160,
              },
              {
                prop: 'standardSkuCode',
                label: 'BjDialogListConfig.SKUcode',
                width: 160,
              },
            ]
            })
          " multiple @confirm="onAddGoodsDialogConfirm" />
  </div>
</template>
<script>
    import viewMiXin from '@/utils/view-mixin.js';
    import { channelApi, afterApi, logisticApi, commonApi, stockApi, orderApi } from '@/api';
    import OrderItemTable from './OrderItemTable';
    import UploadFile from './UploadFile';
    import { randomID, getShippingList } from '@/utils/index';
    import moment from 'moment';
    import { COUNTRY_NAME_AND_TWOCODE } from '@/utils/statics';
    const ADDRESS_PATTERN = /^[A-Za-z0-9 \-\'\.,\/#&:;()]+$/;
    const getDefaultForm = () => {
      return {
        // 订单基础信息
        orderBaseInfoDTO: {
          actionType: '201', // (string, optional): 订单创建类型 , 手工单
          copyOrigin: null, // (string, optional): 复制来源 ,
          channel: null,
          orderRemarks: null,
          orderTime: new Date(),
          deliveryAppointmentTime: null,
          isProvideSize: false,
          truckPickupTime: null,
          palletQty: null,
          outerOrderNo: null,
          storeCode: null,
          storeId: null,
          storeName: null,
          salesEmployeeId: null,
          salesEmployeeRealName: null,
          salesOrganizingId: null,
          takingDeliveryStoreId: null,
          takingDeliveryStoreName: null,
          takingDeliveryWay: '2',
          shippingMethod: null,
          shippingLabels: null,
          orderMaterialList: null,
        },
        // 订单买家信息
        orderBuyerInfoDTO: {
          address: null,
          buyerNick: null,
          buyerRemarks: null,
          city: null,
          cityCode: null,
          country: null,
          countryCode: null,
          district: null,
          districtCode: null,
          phone: null,
          deliveryPhone: null,
          province: null,
          provinceCode: null,
          receiverName: null,
          town: null,
          deliveryAddress2: null,
          deliveryAddress1: null,
          deliveryEmailAddress: null,
          zipCode: null,
        },
        // 订单商品详情
        orderItemDTOList: [],
      };
    };
    export default {
      name: 'BusinessAddThirdOrderCSGView',
      components: { OrderItemTable, UploadFile },
      mixins: [viewMiXin],
      data() {
        return {
          // 表单项栅格宽度：8 表示一行展示三列
          colSpan: 8,
          // 收货国家下拉选项
          COUNTRY_NAME_AND_TWOCODE,
          // 当前客户可用的运输方式列表
          CSG_ORDER_SHIPPING_METHODS_LIST: [],
          // 新增外部订单的完整表单数据
          form: getDefaultForm(),
          // 商品表格当前选中的行
          selectedRow: [],
          // 是否由 CSG 指定物流
          isLogisticsSpecified: false,
          // 是否需要审核报价
          isQuota: false,
          // 是否显示 CSG MANUAL 专属表单项
          isCSGShow: false,
          // 是否显示 CUSTOMER MANUAL 专属表单项
          isCustomerShow: false,
          // 当前运输方式对应的物流商下拉选项
          LogisticsSelectionData: [],
          // 可用仓库列表
          warehouseList: [],
          // 实仓 ID，用于查询商品可用库存
          physicalWarehouseId: null,
          // 仓库初始化任务，库存查询前用于等待仓库数据就绪
          warehouseReadyPromise: null,
          // 已上传的物流面单文件列表
          shippingLabels: [],
          // 已上传的其他相关文件列表
          orderMaterialList: [],
          // 订单提交状态，用于按钮加载及防止重复提交
          isSubmitting: false,
        };
      },
      computed: {
        SELECTED_BJ_EBC_ID() {
          return this.selectedRow.map(e => e.BJ_EBC_ID);
        },
        // 表单校验
        rules() {
          const validateLogistics = (rule, value, callback) => {
            this.$nextTick(() => {
              if (this.isLogisticsSpecified && !this.form.orderBaseInfoDTO.logisticsBusinessName) {
                return callback(new Error(this.$t('chooseText')));
              }
              callback();
            });
          };
          const validateOuterOrderNo = (rule, value, callback) => {
            this.$nextTick(() => {
              if (!this.form.orderBaseInfoDTO.outerOrderNo) {
                return callback(new Error(this.$t('inputText')));
              }
              if (/[^a-zA-Z0-9_#\[\]\(\)\-]/g.test(this.form.orderBaseInfoDTO.outerOrderNo)) {
                return callback(new Error(this.$t('inputPlusText')));
              }
              callback();
            });
          };

          return {
            'orderBaseInfoDTO.channel': [{ required: true, message: this.$t('SalesOrderEntry.form.channel'), trigger: 'change' }],
            'orderBaseInfoDTO.storeCode': [{ required: true, message: this.$t('SalesOrderEntry.form.store'), trigger: 'change' }],
            'orderBaseInfoDTO.outerOrderNo': [{ required: true, validator: validateOuterOrderNo, trigger: 'blur' }],
            'orderBaseInfoDTO.orderTime': [{ required: true, message: this.$t('SalesOrderEntry.form.ordering'), trigger: 'change' }],
            'orderBuyerInfoDTO.receiverName': [{ required: true, message: this.$t('SalesOrderEntry.form.consignee'), trigger: 'blur' }],
            'orderBuyerInfoDTO.deliveryPhone': [{ required: true, message: this.$t('SalesOrderEntry.form.number'), trigger: 'blur' }],
            'orderBaseInfoDTO.takingDeliveryStoreId': [{ required: false, message: this.$t('SalesOrderEntry.form.pickup'), trigger: 'change' }],
            'orderBaseInfoDTO.takingDeliveryWay': [{ required: true, message: this.$t('SalesOrderEntry.form.delivery'), trigger: 'change' }],
            'orderBaseInfoDTO.shippingMethod': [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
            LogisticsSelectionDataRule: { required: true, validator: validateLogistics, trigger: 'change' },
          };
        },
        cptIsPickSelf() {
          return this.form.orderBaseInfoDTO.takingDeliveryWay == '1';
        },
      },
      watch: {
        /** 运输方式 */
        'form.orderBaseInfoDTO.shippingMethod': {
          handler(val) {
            const uploadFileRef1 = this.$refs.UploadFileRef1;
            const uploadFileRef2 = this.$refs.UploadFileRef2;
            if (uploadFileRef1) uploadFileRef1.fileList = [];
            this.shippingLabels = [];
            if (uploadFileRef2) uploadFileRef2.fileList = [];
            this.orderMaterialList = [];
            // 是否指定物流
            this.isCSGShow = false;
            this.isCustomerShow = false;
            this.isLogisticsSpecified = false;
            this.isQuota = false;
            this.form.orderBaseInfoDTO.logisticsBusinessName = null;
            this.form.orderBaseInfoDTO.logisticsCompany = null;
            this.form.orderBaseInfoDTO.logisticsNo = null;
            this.form.orderBaseInfoDTO.deliveryAppointmentTime = null;
            this.form.orderBuyerInfoDTO.buyerRemarks = '';
            if (val === 'CSG MANUAL') {
              this.form.orderBuyerInfoDTO.buyerRemarks = 'CSG manual booking';
              this.isCSGShow = true;
              this.isLogisticsSpecified = true;
            } else if (val === 'CUSTOMER MANUAL') {
              this.form.orderBuyerInfoDTO.buyerRemarks = 'Shipping label print';
              this.isCustomerShow = true;
            }
            if (['CSG MANUAL', 'CUSTOMER MANUAL'].includes(val)) {
              this.getDataOfSearch(val);
            } else {
              this.LogisticsSelectionData = [];
            }
          }
        },
      },
      created() {
        this.initShippingMethods();
        // 获取仓库数据
        this.warehouseReadyPromise = this._getListWarehouses();
        this.getOnlineShopList();
      },
      methods: {
        async initShippingMethods() {
          try {
            const shippingList = await getShippingList(this.$store.getters.cusId);
            this.CSG_ORDER_SHIPPING_METHODS_LIST = Array.isArray(shippingList)
              ? shippingList.filter(item => item && !item.isDisable)
              : [];
          } catch (error) {
            this.CSG_ORDER_SHIPPING_METHODS_LIST = [];
          }
        },
        // 邮箱校验
        validatorEmail(rule, value, callback) {
          if (!value) return callback();
          if (!value.includes('@')) return callback(new Error(this.$t('personal.emailErrorMsg2')));
          callback();
        },
        // 邮编校验
        validatorPostCode(rule, value, callback) {
          if (this.form.orderBaseInfoDTO.shippingMethod === 'PICKUP') {
            return value ? callback(new Error(this.$t('ExternalOrders.addressTips'))) : callback();
          }
          if (!value) return callback(new Error(this.$t('inputText')));
          callback();
        },
        // 地址1校验
        validatorAddress1(rule, value, callback) {
          if (this.form.orderBaseInfoDTO.shippingMethod === 'PICKUP') {
            return value ? callback(new Error(this.$t('ExternalOrders.addressTips'))) : callback();
          }
          if (!value) return callback(new Error(this.$t('inputText')));
          if (!ADDRESS_PATTERN.test(value)) return callback(new Error(this.$t('IncorrectAddressFormatText')));
          callback();
        },
        // 地址2校验 ： 非必填，如果填写就要符合规范
        validatorAddress2(rule, value, callback) {
          if (this.form.orderBaseInfoDTO.shippingMethod === 'PICKUP') {
            return value ? callback(new Error(this.$t('ExternalOrders.addressTips'))) : callback();
          }
          if (!value) return callback();
          if (!ADDRESS_PATTERN.test(value)) return callback(new Error(this.$t('IncorrectAddressFormatText')));
          callback();
        },
        // 获取网店渠道列表
        async getOnlineShopList() {
          try {
            const channelList = await commonApi.getLovsValue({ lovCode: 'SCHL.CHANNEL_TYPE' });
            const manualImportChannel = Array.isArray(channelList) ? channelList.find(item => item.meaning === 'ManualImport') : null;
            if (!manualImportChannel) return;
            this.form.orderBaseInfoDTO.channel = manualImportChannel.value;
            const shopPage = await channelApi.getAllShopPage({
              channelTypeCode: manualImportChannel.value,
              page: 0,
              size: 999,
            });
            const firstStore = shopPage?.content?.[0];
            if (!firstStore) {
              this.form.orderBaseInfoDTO.storeCode = null;
              return;
            }
            this.form.orderBaseInfoDTO.storeCode = firstStore.code;
            this.onChangeStore(firstStore.code, firstStore);
          } catch (error) {
            console.error('Failed to initialize channel and store:', error);
          }
        },
        // 上传的文件列表
        fileListChange1(file = []) {
          const fileList = Array.isArray(file) ? file : [];
          this.shippingLabels = fileList
            .map(item => ({ name: item.name, url: item.url }))
            .filter(item => item.url);
        },
        // 上传的文件列表
        fileListChange2(file = []) {
          const fileList = Array.isArray(file) ? file : [];
          this.orderMaterialList = fileList
            .map(item => ({ fileName: item.name, fileUrl: item.url }))
            .filter(item => item.fileUrl);
        },
        // 获取仓库数据
        async _getListWarehouses() {
          try {
            const res = await commonApi.getListWarehouses({
              code: null,
              name: null,
              typeCode: null,
              status: 1,
            });
            this.warehouseList = Array.isArray(res) ? res : [];
            const physicalWarehouse = this.warehouseList.find(item => item.name === '实仓');
            this.physicalWarehouseId = physicalWarehouse ? physicalWarehouse.id : null;
          } catch (error) {
            this.warehouseList = [];
            this.physicalWarehouseId = null;
            console.error('Failed to initialize warehouses:', error);
          }
        },
        async _getGoodsStockPage(value) {
          if (this.warehouseReadyPromise) {
            await this.warehouseReadyPromise;
          }
          if (this.physicalWarehouseId === null || this.physicalWarehouseId === undefined) {
            const errorMessage = this.$t('BusinessThirdOrderAdd.physicalWarehouseNotFound');
            this.$message.error(errorMessage);
            throw new Error(errorMessage);
          }

          const res = await stockApi.getGoodsStockPage({
            total: 1,
            currentPage: 0,
            page: 0,
            pageSize: 20,
            size: 20,
            warehouseId: [this.physicalWarehouseId],
            skuCode: value,
          });
          return res?.content?.[0]?.stockNum;
        },
        logsome(v, item) {
          this.form.orderBaseInfoDTO.logisticsCompany = v && item ? item.label : '';
        },
        // 获取物流下拉信息
        async getDataOfSearch(val) {
          try {
            const res = await logisticApi.getLogisticsBusiness({
              name: null,
              companyId: null,
              enableFlag: null,
              csgEnableFlag: val === 'CSG MANUAL' ? true : null,
              currentPage: 0,
              page: 0,
              pagesize: 999,
              size: 999,
            });
            if (this.form.orderBaseInfoDTO.shippingMethod !== val) return;
            const logisticsList = Array.isArray(res?.content) ? res.content : [];
            this.LogisticsSelectionData = logisticsList.map(item => {
              return { label: item.logisticsName, value: item.name };
            });
          } catch (error) {
            if (this.form.orderBaseInfoDTO.shippingMethod === val) {
              this.LogisticsSelectionData = [];
            }
          }
        },
        reSetTable() {
          this.$nextTick(() => {
            this.$refs.OrderItemTable.reFresh();
          });
        },
        clearStoreInfo() {
          this.form.orderBaseInfoDTO.storeId = null;
          this.form.orderBaseInfoDTO.storeName = null;
          this.form.orderBaseInfoDTO.salesEmployeeId = null;
          this.form.orderBaseInfoDTO.salesEmployeeRealName = null;
          this.form.orderBaseInfoDTO.takingDeliveryStoreId = null;
          this.form.orderBaseInfoDTO.takingDeliveryStoreName = null;
          this.form.orderBaseInfoDTO.salesOrganizingId = null;
        },
        onChangeChannel() {
          this.clearStoreInfo();
        },
        onChangeStore(v, item) {
          this.clearStoreInfo();
          if (!v || !item) return;
          this.form.orderBaseInfoDTO.storeId = item.id;
          this.form.orderBaseInfoDTO.storeName = item.name;
          this.form.orderBaseInfoDTO.salesOrganizingId = item.salesOrganizingId;
        },
        batchDelete() {
          this.$confirm(this.$t('SalesOrderEntry.form.sure'), this.$t('toast.hintText'), {
            confirmButtonText: this.$t('toast.okText'),
            cancelButtonText: this.$t('toast.cancelText'),
            type: 'warning',
          }).then(() => {
            this.SELECTED_BJ_EBC_ID.forEach(BJ_EBC_ID => {
              const index = this.form.orderItemDTOList.findIndex(e => e.BJ_EBC_ID == BJ_EBC_ID);
              if (index > -1) this.form.orderItemDTOList.splice(index, 1);
            });
            this.msgSuccess(this.$t('SalesOrderEntry.form.succeeded'));
            this.reSetTable();
          });
        },
        onDelete(row) {
          this.$confirm(this.$t('SalesOrderEntry.form.want'), this.$t('toast.hintText'), {
            confirmButtonText: this.$t('toast.okText'),
            cancelButtonText: this.$t('toast.cancelText'),
            type: 'warning',
          }).then(() => {
            const index = this.form.orderItemDTOList.findIndex(e => e.BJ_EBC_ID == row.BJ_EBC_ID);
            if (index > -1) this.form.orderItemDTOList.splice(index, 1);
            this.msgSuccess(this.$t('SalesOrderEntry.form.succeeded'));
            this.reSetTable();
          });
        },
        handleSelectionChange(d) {
          this.selectedRow = [].concat(d.selection);
        },
        addGoodsDialog(REF_NAME = 'dialogListOrdinarySku') {
          this.$refs[REF_NAME].show();
        },
        async onAddGoodsDialogConfirm(data) {
          if (!Array.isArray(data) || data.length === 0 || !data[0].id) return;
          try {
            for (const item of data) {
              const SALES_PRICE = Number(item.salesPrice || 0);
              const CONST_PRICE = Number(item.costPrice || 0);
              const resp = await orderApi.selectSkuCodeBatch({
                skuCode: item.skuCode,
                cusId: this.$store.getters.cusId,
              });
              const stockNum = await this._getGoodsStockPage(item.skuCode);
              this.form.orderItemDTOList.push({
                id: item.id,
                freight: 0,
                skuCode: item.skuCode,
                skuName: item.skuName,
                spuCode: item.spuCode,
                spuName: item.spuName,
                standardSkuCode: item.standardSkuCode,
                giftFlag: '0',
                setMealFlag: item.setFlag,
                outerSingleSaleAmount: 0,
                outerSaleAmount: this.$number2money(SALES_PRICE * 1),
                innerSingleSaleAmount: this.$number2money(SALES_PRICE),
                innerSaleAmount: this.$number2money(SALES_PRICE * 1),
                transPrice: '0.00',
                costPrice: this.$number2money(CONST_PRICE * 1),
                quantity: 1,
                skuId: item.id,
                BJ_EBC_ID: randomID(),
                BJ_HAS_CHILD: !!item.setFlag,
                BJ_PARENT_ID: null,
                isChildSku: false,
                stockNum: stockNum || 0,
                batchNumList: resp.map(batch => {
                  return {
                    value: batch.batchNum,
                    label: batch.batchNum,
                    usableNum: batch.usableNum,
                    bbd: batch.bbd,
                  };
                }),
              });
            }
          } catch (error) {
            console.error('Failed to add goods:', error);
          } finally {
            this.reSetTable();
          }
        },
        /** 确定 */
        onConfirm() {
          if (this.isSubmitting) return;
          this.$refs.form.validate(async valid => {
            if (this.isSubmitting) return;
            if (valid) {
              if (this.form.orderItemDTOList.length === 0) {
                this.$message.error(this.$t('BusinessPurchaseOrder2.dialog.errMsg4'));
                return;
              }

              // CUSTOMER MANUAL：无需仓库提供尺寸，或物流三项任一有值时，三项都必填
              if (this.form.orderBaseInfoDTO.shippingMethod === 'CUSTOMER MANUAL') {
                const hasLogisticsBusinessName = Boolean(
                  this.form.orderBaseInfoDTO.logisticsBusinessName &&
                  this.form.orderBaseInfoDTO.logisticsBusinessName.trim(),
                );
                const hasLogisticsNo = Boolean(
                  this.form.orderBaseInfoDTO.logisticsNo &&
                  this.form.orderBaseInfoDTO.logisticsNo.trim(),
                );
                const hasShippingLabels = this.shippingLabels.length > 0;
                const shouldValidateLogistics =
                  !this.form.orderBaseInfoDTO.isProvideSize ||
                  hasLogisticsBusinessName ||
                  hasLogisticsNo ||
                  hasShippingLabels;

                if (shouldValidateLogistics) {
                  if (!hasLogisticsBusinessName) {
                    return this.$message.error(`${this.$t('inputText')} ： ${this.$t('WarehouseManagement.form.chooseLogistics')}`);
                  }
                  if (!hasLogisticsNo) {
                    return this.$message.error(`${this.$t('inputText')} ： ${this.$t('OrdinaryOrderMix.LogisticsTable.logisticsNo')}`);
                  }
                  if (!hasShippingLabels) {
                    return this.$message.error(`${this.$t('chooseText')} ： ${this.$t('OrdinaryOrderMix.LogisticsTable.Shipment')}`);
                  }
                }

                // 已提供面单时，不再要求仓库提供尺寸信息
                if (hasShippingLabels && this.form.orderBaseInfoDTO.isProvideSize) {
                  this.form.orderBaseInfoDTO.isProvideSize = false;
                }
              }

              const POST_DATA = this.$lodash.clone(this.form);
              // 自提，清空配送信息
              if (this.cptIsPickSelf) {
                POST_DATA.orderBuyerInfoDTO.address = null;
                POST_DATA.orderBuyerInfoDTO.provinceCode = null;
                POST_DATA.orderBuyerInfoDTO.cityCode = null;
                POST_DATA.orderBuyerInfoDTO.districtCode = null;
                POST_DATA.orderBuyerInfoDTO.province = null;
                POST_DATA.orderBuyerInfoDTO.city = null;
                POST_DATA.orderBuyerInfoDTO.district = null;
              }

              // let bstop = true
              const duplicates = new Map();
              const newArr = [];
              POST_DATA.orderItemDTOList.forEach(item => {
                const key = `${item.standardSkuCode}-${item.spuCode}`;
                if (duplicates.has(key)) {
                    newArr.push(item);
                } else {
                    duplicates.set(key, true);
                }
                // if(item.spuCode && item.quantity > item.batchNumList.bjGet(item.spuCode, 'value', 'usableNum')){
                //   bstop = false
                // };
              });
              if (newArr.length > 0) return this.$message.warning(`${newArr[0].standardSkuCode} ${this.$t('dataDuplication')}`);
              // if(!bstop) this.$message.error('Quantity > Available')

              POST_DATA.orderItemDTOList = POST_DATA.orderItemDTOList.map(e => {
                return {
                  giftFlag: e.giftFlag, // (integer, optional): 是否赠品 ,   0 不是赠品  1 是赠品
                  setMealFlag: e.setMealFlag,
                  outerSaleAmount: e.outerSaleAmount, // (number, optional): 外部销售总价  ,
                  outerSingleSaleAmount: e.outerSingleSaleAmount,
                  innerSingleSaleAmount: e.innerSingleSaleAmount,
                  innerSaleAmount: e.innerSaleAmount,
                  transPrice: e.transPrice,
                  quantity: e.quantity, // (integer, optional): 数量 ,
                  skuCode: e.skuCode, // (string, optional): sku编码 ,
                  spuCode: e.spuCode,
                  skuId: e.skuId, // (integer, optional): skuId
                  innerSkuCode: e.skuCode, // 同sku编码

                  outerOrderNo: this.form.orderBaseInfoDTO.outerOrderNo,
                  orderRemarks: this.form.orderBaseInfoDTO.orderRemarks,
                  shippingMethod: this.form.orderBaseInfoDTO.shippingMethod,
                  shippingLabels: this.shippingLabels.length > 0 ? JSON.stringify(this.shippingLabels) : null,
                  orderMaterialList: this.orderMaterialList,
                  orderTime: moment(this.form.orderBaseInfoDTO.orderTime).format('YYYY-MM-DD HH:mm:ss'),
                  deliveryAppointmentTime: this.form.orderBaseInfoDTO.deliveryAppointmentTime ? moment(this.form.orderBaseInfoDTO.deliveryAppointmentTime).format('YYYY-MM-DD HH:mm:ss') : null,
                  truckPickupTime: this.form.orderBaseInfoDTO.truckPickupTime ? moment(this.form.orderBaseInfoDTO.truckPickupTime).format('YYYY-MM-DD HH:mm:ss') : null,
                  isProvideSize: this.form.orderBaseInfoDTO.isProvideSize,
                  palletQty: this.form.orderBaseInfoDTO.palletQty,
                  shippingWarehouse: null, // 原始发货仓库
                  goodsQuantity: e.quantity,
                  confirmed: null, // 证明，批准
                  webReference: null, // 网络参考
                  distributionCenterType: null, // 配送中心类型
                  ECommerceOrderRef: null, // 电子商务订单参考
                  siteListingId: null, // 建筑上市Id
                  lineOrderCustomerRef: null, // 订单生产客户编号
                  route: null, // 渠道，路线
                  barCode: null, // 条形码
                  storeCode: this.form.orderBaseInfoDTO.storeCode,
                  orderSource: this.form.orderBaseInfoDTO.orderSource,
                  totalPrice: 0,
                  logisticsNo: this.form.orderBaseInfoDTO.logisticsNo || null,
                  deliveryName: this.form.orderBuyerInfoDTO.receiverName,
                  deliveryPhone: this.form.orderBuyerInfoDTO.deliveryPhone,
                  deliveryAddress1: this.form.orderBuyerInfoDTO.deliveryAddress1,
                  deliveryAddress2: this.form.orderBuyerInfoDTO.deliveryAddress2,
                  deliveryState: this.form.orderBuyerInfoDTO.province,
                  deliveryPostcode: this.form.orderBuyerInfoDTO.zipCode,
                  deliverySuburb: this.form.orderBuyerInfoDTO.district,
                  destCountry: this.form.orderBuyerInfoDTO.country,
                  deliveryEmailAddress: this.form.orderBuyerInfoDTO.deliveryEmailAddress,
                  comments: this.form.orderBuyerInfoDTO.buyerRemarks,
                  buyerRemarks: this.form.orderBuyerInfoDTO.buyerRemarks,
                  isLogisticsSpecified: this.isLogisticsSpecified ? '1' : '0',
                  isNeedQuota: this.isQuota ? 1 : 0,
                  logisticsName: this.form.orderBaseInfoDTO.logisticsBusinessName,
                  logisticsCompany: this.form.orderBaseInfoDTO.logisticsCompany,
                  logisticsBusinessName: this.form.orderBaseInfoDTO.logisticsBusinessName,
                  shippingType: this.form.orderBuyerInfoDTO.shippingType,
                  unitprice: e.outerSingleSaleAmount,
                  // amount: e.outerSingleSaleAmount * e.quantity,
                  freight: e.freight,
                  actionType: 101
                };
              });
              this.isSubmitting = true;
              let submitSucceeded = false;
              try {
                const res = await afterApi.addInternalResendOrder(POST_DATA.orderItemDTOList);
                submitSucceeded = Boolean(res && (res.id || res._token || res.content || Array.isArray(res) || res.failed === false));
                if (submitSucceeded) {
                  this.$message.success(this.$t('SalesOrderEntry.form.Submitted'));
                  setTimeout(() => {
                    this.isSubmitting = false;
                    this.complete('BusinessAbnormalOrderSTOCK');
                  }, 1000);
                }
              } catch (error) {
                console.error('Failed to submit order:', error);
              } finally {
                if (!submitSucceeded) this.isSubmitting = false;
              }
            }
          });
        },
      },
    };
</script>
<style lang="scss" scoped>
.bottom .el-form-item {
  margin-bottom: 0;
}
.price {
  font-size: 16px;
  font-weight: bold;
}
.hint {
  line-height: 15px;
  margin-top: -10px;
  color: #b2b2b2;
}
::v-deep .avatar-uploader .el-upload {
  border: none;
}
</style>
